import React from "react";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import es from "react-phone-number-input/locale/es.json";
import _ from "lodash";
import SelectCodNumber from "../Select/SelectCodNumber";

const sortedCountries = (countries, labels) => {
  const listOfCountries = [];
  countries.forEach((country) => {
    listOfCountries.push({
      label: `${labels[country]} +${getCountryCallingCode(country)}`,
      value: `${labels[country]} +${getCountryCallingCode(country)}`,
      numericValue: parseInt(getCountryCallingCode(country)),
    });
  });
  return [
    {
      label: "Costa Rica +506",
      value: "Costa Rica +506",
      numericValue: 506,
    },
  ].concat(
    _.sortBy(listOfCountries, (c) => {
      return c.label;
    })
  );
};

export function ClienteEntregaForm({
  nombre,
  telefono,
  codigoPaisTelefono = 506,
  onChangeNombre,
  onChangeTelefono,
  onChangeCodigoPaisTelefono,
  labelColor = "text-base",
  optional = false,
}) {
  return (
    <div className="w-full mt-4">
      <p className={`${labelColor} font-medium mb-2`}>
        Datos del cliente para la entrega
      </p>
      {optional && (
        <p className={`${labelColor} text-sm mb-2`}>
          Opcional — si no se completa, se usará Cliente en tienda
        </p>
      )}
      <div className="w-full mt-2">
        <label htmlFor="clienteEntregaNombre" className={labelColor}>
          Nombre completo del cliente:
          {!optional && <span className="text-pink">*</span>}
        </label>
        <input
          id="clienteEntregaNombre"
          name="clienteEntregaNombre"
          className="appearance-none w-full rounded-3xl my-2 h-12 p-6 border border-purple"
          value={nombre}
          onChange={(evt) => onChangeNombre(evt.target.value)}
        />
      </div>
      <div className="w-full mt-2">
        <SelectCodNumber
          required={!optional}
          containerClasses="my-2"
          labelColor={labelColor}
          buttonClasses="border border-purple"
          label="Código telefónico de país:"
          options={sortedCountries(getCountries(), es)}
          onChange={(value, option, numericValue) => {
            onChangeCodigoPaisTelefono(numericValue, option);
          }}
          value={codigoPaisTelefono}
          CodNumber={codigoPaisTelefono}
        />
      </div>
      <div className="w-full mt-2">
        <label htmlFor="clienteEntregaTelefono" className={labelColor}>
          Teléfono del cliente:
          {!optional && <span className="text-pink">*</span>}
        </label>
        <input
          id="clienteEntregaTelefono"
          name="clienteEntregaTelefono"
          className="appearance-none w-full rounded-3xl my-2 h-12 p-6 border border-purple"
          value={telefono}
          placeholder="Por favor ingresá únicamente números"
          onChange={(evt) => {
            onChangeTelefono(evt.target.value.replace(/[^0-9]/g, ""));
          }}
        />
      </div>
    </div>
  );
}

export default ClienteEntregaForm;
